import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { useLanguage } from "@/contexts/LanguageContext";

/* Global gate: any wa.me / WhatsApp link on the public site requires a registered,
   logged-in client. Anonymous clicks are redirected to /registro (capture phase,
   so it works for every existing <a href="https://wa.me/..."> without editing them). */
export const WhatsAppGate = () => {
  const { user, loading } = useAuth();
  const { lang } = useLanguage();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (loading || user) return undefined;
    const handler = (e) => {
      const a = e.target?.closest?.("a[href]");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      if (!/wa\.me|api\.whatsapp\.com|whatsapp:\/\//i.test(href)) return;
      e.preventDefault();
      e.stopPropagation();
      toast(lang === "es" ? "Regístrate gratis para enviarme un mensaje por WhatsApp" : "Sign up for free to message me on WhatsApp");
      navigate(`/registro?next=${encodeURIComponent(pathname || "/")}`);
    };
    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, [user, loading, lang, navigate, pathname]);

  return null;
};

export default WhatsAppGate;
